/*
  Team registration codes.

  Codes come from GET /api/v1/teams?campaign=<id>, which surfaces two
  per team: `memberCode` (role = 1) and `teamLeadCode` (role = 2). The
  dashboard displays the MEMBER code — the one participants enter to
  join. The team lead code must not be shown here.

  The API returns "" when a team has no member code, so callers get a
  dash rather than an empty cell.
*/

export const NO_CODE_PLACEHOLDER = "—";

export function getTeamCode(team) {
  return team.memberCode || NO_CODE_PLACEHOLDER;
}

/*
  "The Crocodiles" -> "CR", "East Broncos" -> "EB".
  Leading article is dropped; a single remaining word uses its first
  two letters, otherwise the initial of each of the first two words.
*/
export function getTeamInitials(name) {
  if (!name) return "";

  const words = name
    .trim()
    .split(/\s+/)
    .filter((word) => word.toLowerCase() !== "the");

  if (!words.length) return name.slice(0, 2).toUpperCase();

  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();

  return `${words[0][0]}${words[1][0]}`.toUpperCase();
}
